import { html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { classMap } from 'lit/directives/class-map.js'
import { SlotController } from '../common/controllers/SlotController.js'

import componentStyle from '../common/styles/Component.css'
import style from './SegmentedControl.css'

/**
 * Segmented control is used to pick one choice from a set of
 * closely related choices, and immediately apply that selection.
 *
 * @status new
 * @category action
 * @slot - Default slot.
 *
 * @fires {NordEvent} change - Fired whenever a segmented control item has been checked.
 */
@customElement('nord-segmented-control')
export default class SegmentedControl extends LitElement {
  static styles = [componentStyle, style]

  private defaultSlot = new SlotController(this)

  /**
   * Controls whether the segmented control expands to fill the width of its container.
   */
  @property({ reflect: true, type: Boolean }) expand = false

  render() {
    const isDisabled = this.defaultSlot.assigned.every((node) => {
      if (node.hasAttribute('disabled')) {
        return true
      }
      return false
    })

    return html`<div
      class=${classMap({
        'n-segmented-control': true,
        'n-disabled': isDisabled,
      })}
    >
      <slot></slot>
    </div>`
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-segmented-control': SegmentedControl
  }
}
